import request from '@zh-or/lib/request';
import t from '@zh-or/lib';
import jumpLogin from "../lib/jumpLogin.js";

import {userStore} from '../lib/store.js';
function getDefHost() {
    return '';
    //return 'https://bnd.yuanmuzi.com';
    //return 'https://wx.yuanmuzi.com';
    //return 'https://yj.cqqgkj.com';
}

let req = new request({
    host: getDefHost(),
    timeout: 1000 * 60 * 2,
    headers: {
    }
});


req.reqFilter((req) => {
    let user = userStore();
    let token = user.token;
    if(token) {
        req.headers.token = token;
        if(req.data instanceof FormData) {
            req.data.append('token', token);
        } else {
            req.data.token = token
        }
    }
});

let noMsg = ['/api/index/pubAuth'];

req.resFilter((res) => {
    try {
        let obj = JSON.parse(res.response);
        if(obj.code === 401 || obj.code === 402) {
            //msg.error('请先登录');
            jumpLogin();
            return;
        }
/*console.log(
    !noMsg.some(_ => res.request.url.indexOf(_) !== -1),
    res.request.url,
    noMsg
)*/
        if(obj.code !== 1 && !noMsg.some(_ => res.request.url.indexOf(_) !== -1)) {
            t.showToast(obj.msg);
        }

        return obj;
    } catch(e) {
        console.error('解析JSON出错:', e, res);
    }
    return res.response;
});

req.errFilter((e, res) => {
    console.error(e, res);
    //t.showToast('网络错误');

});

export default req;
